import React, {FunctionComponent} from "react";

import './TargetCounts.scss';
import {AsyncStatus} from "enums";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {pluralize} from "services/Utils";

interface TargetCountsProps {
    status: AsyncStatus,
    numLocations: number,
    numDevices: number,
}

export const TargetCounts: FunctionComponent<TargetCountsProps> = function TargetCounts(props) {
    let { status, numLocations, numDevices } = props;

    return (<>
        <div className="targetCountsBadge">
            <FontAwesomeIcon icon="hdd" className="targetCountsBadge_icon" />
            {numDevices || 0} {pluralize(numDevices, 'Device', 'Devices')}
        </div>
        <div className="targetCountsBadge targetCountsBadge_last">
            <FontAwesomeIcon icon="home" className="targetCountsBadge_icon" />
            {numLocations || 0} {pluralize(numLocations, 'Location', 'Locations')}
        </div>
    </>)
}